import React from 'react';
import { motion } from 'framer-motion';

const ProfileImage: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="relative group"
      whileHover={{ scale: 1.01 }}
    >
      <div className="relative mx-auto h-[26rem] w-80 sm:h-[30rem] sm:w-[22rem] lg:h-[33rem] lg:w-[25rem]">
        {/* Cleaner image shell: soft glow and restrained border instead of layered overlays */}
        <div className="absolute inset-0 rounded-[2rem] bg-cosmic-aurora-sapphire/10 blur-3xl transition-all duration-500 group-hover:bg-cosmic-aurora-sapphire/15" />

        <div className="absolute inset-0 rounded-[2rem] border border-slate-200 bg-slate-50 shadow-[0_18px_48px_rgba(15,23,42,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-[#0f1115]/60 dark:shadow-[0_24px_80px_rgba(0,0,0,0.38)]" />

        <div className="absolute inset-0 rounded-[2rem] p-3">
          <img
            src="/Images/Image.png"
            alt="Shivansh Mane"
            className="h-full w-full rounded-[1.45rem] object-cover object-top shadow-2xl"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default ProfileImage;
